module.exports = __webpack_public_path__ + "media/images/icons/image-e89c0228c43681b44b10ec3a56c19319.svg";